<template>
  <li
    :class="{
      [`${el}__secondaryListItem`]: true,
      [`${el}__activeLink`]: subNavItem.active,
    }"
  >
    <Link
      :class="`${el}__listItemLink ${el}__listItemLink--secondary`"
      :to="subNavItem.to"
      weight="regular"
      :size="$matchMedia.l ? 's' : 'm'"
      v-bind="{ ...(subNavItem.subNavItem && { onClick: toggleShowSubNav }) }"
    >
      <span :class="`${el}__listItemLinkPrimaryText1`">{{ subNavItem.text }}</span>
      <Icon
        v-if="subNavItem.subNavItem"
        name="arrow-right-s-line"
        color="primaryBlue"
        :class="`${el}__subNavIcon${showSubNav ? ` ${el}__subNavIcon--rotate` : ''}`"
      />
      <span v-if="subNavItem.isNew" :class="`${el}__isNew`">Neu</span>
    </Link>

    <ul
      v-if="subNavItem.subNavItem"
      ref="navRef"
      :class="{
        [`${el}__tertiaryList`]: true,
        [`${el}__tertiaryList--show`]: showSubNav,
      }"
      :style="`max-height: ${showSubNav ? scrollHeight * 1.2 : 0}px`"
    >
      <li
        v-for="(tertiarySubNavItem, k) in subNavItem.subNavItem"
        :key="`tertiaryListItem-${k}`"
        :class="`${el}__tertiayListItem`"
      >
        <Link
          :class="{
            [`${el}__listItemLink`]: true,
            [`${el}__listItemLink--secondary`]: true,
            [`${el}__activeLink`]: tertiarySubNavItem.active,
          }"
          :to="tertiarySubNavItem.to"
          weight="regular"
          :size="$matchMedia.l ? 's' : 'm'"
        >
          {{ tertiarySubNavItem.text }}
          <span v-if="tertiarySubNavItem.isNew" :class="`${el}__isNew`">Neu</span>
        </Link>
      </li>
    </ul>
  </li>
</template>

<script>
import Link from '@/objects/Link';
import Icon from '@/objects/Icon';

export default {
  name: 'SecondaryNavItem',
  props: {
    subNavItem: Object,
    el: String,
    idx: Number,
    isPopover: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Link,
    Icon,
  },
  data() {
    return {
      showSubNav: false,
      height: 0,
      scrollHeight: 0,
    };
  },
  created() {
    if (this.subNavItem.subNavItem) {
      const match = this.subNavItem.subNavItem.filter((sni) => sni.active)[0];
      if (match) {
        this.showSubNav = true;
      }
    }
  },
  mounted() {
    if (this.$refs.navRef) {
      this.scrollHeight = this.$refs.navRef.scrollHeight;
    }
  },
  methods: {
    toggleShowSubNav() {
      this.showSubNav = !this.showSubNav;
    },
  },
};
</script>
